module.exports = __webpack_public_path__ + "static/img/cloud-right-top.9e67079.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/cloud-right-top.png
// module id = 659
// module chunks = 64